import left from "images/cscec3b/jczq-t-left"
import leftw from "images/cscec3b/jczq-t-leftw"
import right from "images/cscec3b/jczq-t-right"
import rightw from "images/cscec3b/jczq-t-rightw"
import { DeviceContext, MediaQueryContext } from "libs/contexts"
import { webps } from "libs/imgs"
import { CSSProperties, useContext } from "react"

webps[left] = leftw
webps[right] = rightw

export default function SectionTitle({
  title,
  styles,
}: {
  title: string
  styles?: CSSProperties
}) {
  const { phoneBreakpoint } = useContext(MediaQueryContext)
  const { buildImgSrc } = useContext(DeviceContext)

  return (
    <div className="title" style={styles}>
      <img src={buildImgSrc(left)} alt="" />
      <span>{title}</span>
      <img src={buildImgSrc(right)} alt="" className="right" />
      <style jsx>{`
        .title {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 8px;
          line-height: 1;
        }
        .title span {
          font-size: 24px;
          color: #333333;
          padding: 0 12px;
        }
        .title img {
          width: 20px;
        }
      `}</style>
      <style jsx>{`
        @media ${phoneBreakpoint} {
          .title span {
            font-size: 20px;
            color: #333333;
            padding: 0 12px;
          }
        }
      `}</style>
    </div>
  )
}
